/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography, TextField, Pagination, Select, MenuItem } from '@mui/material';
// import SearchIcon from '@mui/icons-material/Search';
import { useLocation } from 'react-router-dom';
import { useUserContext } from 'UserProvider';
import moodleAxios from '../../services/moodle/moodleApi';
import { token } from 'utils/baseURLs';
const GradesPage = () => {
  const [htmlContent, setHtmlContent] = useState('');

  const [error, setError] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const itemsPerPage = 10; // You can adjust the number of items per page
  const location = useLocation();
  // console.log(location, location.state.courseID);
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCourse, setSelectedCourse] = useState('');
  const [selectedCourseId, setSelectedCourseId] = useState('');
  const { userContext } = useUserContext(); // Destructure userContext
  // console.log(selectedCourse);
  useEffect(() => {
    const fetchCourses = async () => {
      // console.log('it got hit');
      const userId = userContext?.userData?.id || localStorage.getItem('userid');

      if (!userId) {
        // console.error('User context and session storage userId are not available');
        return;
      }

      setLoading(true);
      try {
        const res = await moodleAxios.post(
          `/webservice/rest/server.php?wstoken=${token}&wsfunction=mod_kb_get_user_kb_courses&moodlewsrestformat=json&userid=${userId}`
        );
        // console.log(res);
        if (res.data) {
          setCourses(res.data);
        }
      } catch (error) {
        // console.error('Error fetching courses:', error);
      } finally {
        setLoading(false);
      }
    };

    // Check if there's an activity instance or a user token in session storage
    const activityInstance = sessionStorage.getItem('activityInstance');
    const usrtoken = sessionStorage.getItem('token');

    // Only fetch courses if activityInstance or usrtoken exists
    if (activityInstance || usrtoken) {
      fetchCourses();
    }
  }, [userContext]);

  useEffect(() => {
    const fetchGrades = async () => {
      try {
        const userData = localStorage.getItem('UserData')
          ? JSON.parse(localStorage.getItem('UserData'))
          : null;
        const userId = userData ? userData.userData.id : sessionStorage.getItem('userid');
        const courseId = selectedCourseId;

        if (!userId) {
          setError('User ID not found');
          setLoading(false);
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_MOODLE_DEVELOPMENT_URL}/webservice/rest/server.php`,
          {
            params: {
              wstoken: process.env.REACT_APP_MOODLE_Token,
              wsfunction: 'gradereport_user_get_grades_table',
              moodlewsrestformat: 'json',
              courseid: courseId,
              userid: userId
            }
          }
        );

        if (response.data && response.data.tables) {
          const tableRows = response.data.tables[0].tabledata;

          const rowsWithAnchorTag = tableRows.filter(row => {
            if (!row.itemname || !row.itemname.content) return false;

            const content = row.itemname.content;

            // Check if it includes an anchor tag at all
            if (!content.includes('<a ')) return false;

            // Use a regex to extract the content inside <a>...</a>
            const anchorTextMatch = content.match(/<a [^>]*>([\s\S]*?)<\/a>/i);
            if (!anchorTextMatch) return false;

            const anchorInnerHtml = anchorTextMatch[1].trim();

            // Remove any HTML tags inside the anchor content to isolate text
            const anchorInnerText = anchorInnerHtml.replace(/<[^>]+>/g, '').trim();

            // Only include if there's non-empty text inside the anchor
            return anchorInnerText.length > 0;
          });
          setFilteredData(rowsWithAnchorTag);
          setHtmlContent(rowsWithAnchorTag);
        } else {
          setError('No grades found');
        }
      } catch (err) {
        setError('Error fetching grades');
        // console.error(err);
      } finally {
        setLoading(false);
      }
    };
    if (selectedCourseId !== '') {
      fetchGrades();
    }
  }, [selectedCourseId]);

  // Handle Pagination
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };
  const handleChange = event => {
    setSelectedCourseId(event.target.value);
    setLoading(true);
  };

  // Handle Search Functionality
  const handleSearchChange = event => {
    const search = event.target.value.toLowerCase();
    setSearchTerm(search);

    const filtered = htmlContent.filter(row => row.itemname.content.toLowerCase().includes(search));
    setFilteredData(filtered);
    setCurrentPage(1);
  };

  // Pagination Data Slice
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = filteredData.slice(startIndex, startIndex + itemsPerPage);
  // Render the grades table in HTML format
  const renderTableRows = () => {
    if (paginatedData.length === 0) {
      return '<tr><td colspan="2">No results found</td></tr>';
    }

    return paginatedData
      .map(row => {
        // Parse the HTML content of 'itemname' to get the title/text
        const parser = new DOMParser();
        const doc = parser.parseFromString(row.itemname?.content || '', 'text/html');
        const titleText = doc.querySelector('a')?.textContent || 'N/A'; // Extract anchor text

        const grade = row.grade?.content || 'No grade available';

        // Only return rows where titleText and grade are valid
        if (titleText === 'N/A' || grade === 'No grade available') {
          return ''; // Skip this row
        }

        // console.log(titleText);

        return `<tr><td>${titleText}</td><td>${grade}</td></tr>`;
      })
      .join('');
  };
  // console.log(selectedCourseId);
  return (
    <Box sx={{ padding: 2 }}>
      <Typography variant="h4" gutterBottom sx={{ textAlign: 'center', marginBottom: '20px' }}>
        Grades
      </Typography>
      {courses.length > 0 ? (
        <Select
          style={{ margin: '10px' }}
          value={selectedCourseId || ''}
          onChange={event => handleChange(event)}
          displayEmpty>
          <MenuItem value="">Select a course</MenuItem>
          {courses.map(course => (
            <MenuItem key={course.id} value={course.id}>
              {course.fullname}
            </MenuItem>
          ))}
        </Select>
      ) : (
        <Typography>Loading courses...</Typography>
      )}

      {/* Search Bar */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '20px',
          boxShadow: '10px 10px 20px #d1d9e6, -10px -10px 20px #ffffff',
          padding: '10px',
          borderRadius: '30px',
          backgroundColor: '#e1e6ed'
        }}>
        <TextField
          variant="outlined"
          placeholder="Search by Class"
          value={searchTerm}
          onChange={handleSearchChange}
          //   InputProps={{
          //     endAdornment: (
          //       <IconButton>
          //         <SearchIcon />
          //       </IconButton>
          //     )
          //   }}
          sx={{
            width: '60%',
            boxShadow: 'inset 8px 8px 16px #d1d9e6, inset -8px -8px 16px #ffffff',
            borderRadius: '20px'
          }}
        />
      </Box>

      {loading ? (
        <Typography>Loading...</Typography>
      ) : error ? (
        <Typography color="error">{error}</Typography>
      ) : (
        <Box
          sx={{
            boxShadow: '10px 10px 20px #d1d9e6, -10px -10px 20px #ffffff',
            padding: '20px',
            borderRadius: '20px',
            backgroundColor: '#e1e6ed'
          }}>
          {/* Table */}
          <Box
            dangerouslySetInnerHTML={{
              __html: `
               <table border="1" style="width:100%; border-collapse: collapse; text-align: center;">
                 <thead>
                   <tr>
                     <th>Exercise</th>
                     <th>Grade</th>
                   </tr>
                 </thead>
                 <tbody>
                   ${renderTableRows()}
                 </tbody>
               </table>
             `
            }}
          />
        </Box>
      )}

      {/* Pagination */}
      {filteredData.length > itemsPerPage && (
        <Box
          sx={{
            marginTop: '20px',
            display: 'flex',
            justifyContent: 'center'
          }}>
          <Pagination
            count={Math.ceil(filteredData.length / itemsPerPage)}
            page={currentPage}
            onChange={handlePageChange}
            sx={{
              '& .Mui-selected': {
                backgroundColor: '#8492ab',
                color: '#ffffff'
              }
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default GradesPage;
